import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppPlugin } from '..';
import { CandidateExperienceApp } from '../../candidate_experience/containers/CandidateExperienceApp';

export class CandidateExperienceAppPlugin implements AppPlugin {
  public load(): void {
    const el = document.getElementById('candidateExperienceApp');

    if (el) this.installContainer(el);
  }

  private installContainer(el: HTMLElement): void {
    const props = JSON.parse(el.dataset['props'] || '{}');

    createRoot(el).render(React.createElement(CandidateExperienceApp, props));
  }
}
